import React, { FC, useState } from 'react';
import ActionButton from '~components/atoms/ActionButton';
import Modal from '~components/atoms/Modal';
import Table from '~components/molecules/Table';
import ViewSerialNoModalModal from '~components/molecules/ViewSerialNoModal';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TransactionActionEnum } from '~utils/enums';
import EarmarkModalContent from './EarmarkModal';

type GoldTransactionItemsProps = {
    isOpen: boolean;
    onClose: () => void;
    isLoading: boolean;
    mode: 'view' | 'earmark' | 'edit';
}

const GoldTransactionProductDetailsTable: FC<GoldTransactionItemsProps> = ({ isOpen, onClose, isLoading, mode }) => {
    const dispatch = useAppDispatch();

    const selectedTransaction = useAppSelector((state) => state.gold.buyAndSellGold.selectedTransaction);
    const discountList = useAppSelector((state) => state.setting.discounts.data);

    const [serialNoList, setSerialNoList] = useState<string[]>([]);
    const [isSerialNoModalOpen, setIsSerialNoModalOpen] = useState(false);

    const setIsTransactionDetailsModalOpen = (state: boolean) => dispatch(combinedActions.goldSetIsTransactionDetailsModalOpen(state));

    const tableHeader = [
        'ID',
        'PRODUCT ID',
        'PRODUCT NAME',
        'DESCRIPTION',
        'AMOUNT',
        'PHYSICAL GOLD WEIGHT',
        'TOTAL WEIGHT',
        'GOLD PRICE',
        'SERIAL NO.',
        'DISCOUNT NAME',
        'DISCOUNT CODE',
        'DISCOUNT TYPE',
        'DISCOUNTED PRICE',
        'NET VALUE PER TRANSACTION ITEM',
        'ACTION',
    ];

    const tableBody = selectedTransaction?.items.map((item) => {

        const {
            customerTransactionItemId,
            productId,
            productName,
            description,
            amount,
            physicalGoldWeight,
            totalWeight,
            goldPrice,
            serialNo,
            discountName,
            discountCode,
            discountTransactionType,
            discountedPrice,
            netValuePerTransactionItem,
        } = item;

        // const getDiscountName = () => {
        //     const selectedDiscount = discountList.find(discount => discount.discountId === discountId);

        //     if (!selectedDiscount) return '-';

        //     return selectedDiscount;
        // };

        const handleViewSerialNo = () => {
            setIsSerialNoModalOpen(true);
            setSerialNoList(serialNo);
        };

        const renderSerialNo = () => {
            return (
                <ActionButton
                    key={customerTransactionItemId}
                    label='View'
                    onClick={() => handleViewSerialNo()}
                />
            );
        };

        const renderActionButton = () => {
            return (
                <ActionButton
                    label='View Receipt'
                    onClick={() => setIsTransactionDetailsModalOpen(true)}
                />
            );
        };

        const getDiscountType = (discountType: TransactionActionEnum) => {
            if (discountType === TransactionActionEnum['Bank Sell']) {
                return (
                    <div>
                        <p>Discount</p>
                        <p>(Bank Sell)</p>
                    </div>
                );
            }

            if (discountType === TransactionActionEnum['Bank Buy']) {
                return (
                    <div>
                        <p>Markup</p>
                        <p>(Bank Buy)</p>
                    </div>
                );
            }
        };

        return [
            customerTransactionItemId,
            productId,
            productName,
            description,
            amount,
            physicalGoldWeight || 'N/A',
            totalWeight,
            (Math.round(Number(goldPrice) * 100) / 100).toFixed(2),
            renderSerialNo(),
            discountName || '-',
            discountCode || '-',
            discountTransactionType ? getDiscountType(discountTransactionType) : '-',
            discountedPrice || '-',
            netValuePerTransactionItem ? `RM${(Math.round(Number(netValuePerTransactionItem) * 100) / 100).toFixed(2)}` : '-',
            renderActionButton(),
        ];
    }) || [];

    const getTitle = () => {
        switch (mode) {
            case 'view': return 'Transaction Product List';
            case 'earmark': return 'Convert Transaction to Earmark';
            case 'edit': return 'Edit Earmark Details';
            default: return '';
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={getTitle()}
        >
            {mode === 'view' ? (
                <Table
                    header={tableHeader}
                    body={tableBody}
                    isLoading={isLoading}
                />
            ) : mode === 'earmark' ? (
                <EarmarkModalContent transaction={selectedTransaction} onClose={onClose} />
            ) : (
                <EarmarkModalContent transaction={selectedTransaction} onClose={onClose} mode='edit' />
            )}

            <ViewSerialNoModalModal
                isOpen={isSerialNoModalOpen}
                onClose={() => setIsSerialNoModalOpen(false)}
                serialNo={serialNoList}
            />
        </Modal>
    );
};

export default GoldTransactionProductDetailsTable;
